import {OrderType} from "@/enums";
import Order from "@/model/Order";
import CustomerServiceV2 from "@/service/CustomerServiceV2";
import moment from "moment";
import CustomerOrderService from "@/service/CustomerOrderService";
import DateUtils from "@/DateUtils";

export const createDefaultInventoryOrder = (customerUuid: string | null = null, validFrom: string | null = null, validTo: string | null = null): Order => {
  const defaultInventoryOrder = new Order();
  if (customerUuid) {
    CustomerServiceV2.getCustomer(customerUuid)
      .then(customer => {
        defaultInventoryOrder.name = customer.name;
        if (customer.address) {
          defaultInventoryOrder.address = customer.address.street;
          defaultInventoryOrder.zip = customer.address.zip as unknown as string | null;
          defaultInventoryOrder.city = customer.address.city as unknown as string | null;
          defaultInventoryOrder.positions = customer.positions;
        }

        const customerCategory = {
          fruitAndVegetables: customer.og ?? false,
          flowers: customer.flowers ?? false,
          storage: customer.storage ?? false,
          targetActualComparison: customer.targetActualComparison ?? false,
          labels: customer.labels ?? false,
          drinks: customer.drinks ?? false,
        };

        defaultInventoryOrder.customerCategory = customerCategory;

        defaultInventoryOrder.customer = customer;
      });
  }

  defaultInventoryOrder.orderType = OrderType.INV;
  if (validFrom) {
    const validFromDate = moment(validFrom, "YYYY-MM-DD");
    if (!validFromDate.isBefore(moment())) {
      defaultInventoryOrder.validFrom = moment(validFrom).format("YYYY-MM-DD");
    } else {
      defaultInventoryOrder.validFrom = moment().format("YYYY-MM-DD");
    }
  } else {
    defaultInventoryOrder.validFrom = moment().format("YYYY-MM-DD");
  }

  if (validTo) {
    const validToDate = moment(validTo, "YYYY-MM-DD");
    if (!validToDate.isBefore(moment())) {
      defaultInventoryOrder.validTo = moment(validTo).format("YYYY-MM-DD");
    } else {
      defaultInventoryOrder.validTo = moment().format("YYYY-MM-DD");
    }
  } else {
    defaultInventoryOrder.validTo = moment().format("YYYY-MM-DD");
  }

  defaultInventoryOrder.startTime = "07:00";
  return defaultInventoryOrder;
};

export const updateInventoryOrderCustomer = (inventoryOrder: Order = new Order(), customerUuid: string | null = null): void => {
  if (customerUuid) {
    CustomerServiceV2.getCustomer(customerUuid)
      .then(customer => {
        inventoryOrder.name = customer.name;
        inventoryOrder.address = customer.address.street;
        inventoryOrder.zip = customer.address.zip as unknown as string | null;
        inventoryOrder.city = customer.address.city as unknown as string | null;
        const customerCategory = {
          fruitAndVegetables: customer.og ?? false,
          flowers: customer.flowers ?? false,
          storage: customer.storage ?? false,
          targetActualComparison: customer.targetActualComparison ?? false,
          labels: customer.labels ?? false,
          drinks: customer.drinks ?? false,
        };
        inventoryOrder.customerCategory = customerCategory;
        inventoryOrder.customer = customer;
      });
  }
};

// Takes the positions of the customer's latest past inventory that has positions recorded on it
export const updatePositions = (inventoryOrder: Order = new Order(), customerUuid: string | null = null): void => {
  if (customerUuid) {
    CustomerOrderService.findInventoryOrderSummariesStartingBefore(customerUuid, DateUtils.today())
      .then(response => {
        const latest = response.data.orderSummaries.find(summary => summary.positions != null);
        if (latest) {
          inventoryOrder.positions = latest.positions;
        }
      });
  }
};
